<mat-card appearance="outlined">
  <mat-card-content>
    <table class="table table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">#</th>
          <th scope="col">Naam</th>
          <th scope="col">Datum</th>
          <th scope="col">Status</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
      @for (tournament of getActiveTournaments(); track tournament.id) {
        <tr>
          <td class="align-middle">{{ tournament.id }}</td>
          <td class="align-middle"><a [routerLink]="['/tournaments', tournament.id, 'manage']">{{ tournament.name }}</a></td>
          <td class="align-middle">{{ tournament.date }}</td>
          <td class="align-middle">{{ Tournament.getStatus(tournament) }}</td>
          <td class="align-middle">
            @if (Tournament.getStatus(tournament) != 'Afgerond') {
              <a mat-button [routerLink]="['/tournaments', tournament.id, 'edit']">
                <mat-icon>edit</mat-icon>
                Bewerk
              </a>
            }
            <a mat-button [routerLink]="['/tournaments', tournament.id, 'registrations']">
              <mat-icon>group</mat-icon>
              Inschrijvingen
            </a>
            @if (Tournament.getStatus(tournament) == 'Geloot') {
              <a mat-button (click)="clearDraw(tournament)">
                <mat-icon>safety_divider</mat-icon>
                Loting wissen
              </a>
            }
          </td>
        </tr>
      }
      @if (showInactive) {
        @for (tournament of getInactiveTournaments(); track tournament.id) {
          <tr>
            <td class="align-middle">{{ tournament.id }}</td>
            <td class="align-middle"><a [routerLink]="['/tournaments', tournament.id, 'manage']">{{ tournament.name }}</a></td>
            <td class="align-middle">{{ tournament.date }}</td>
            <td class="align-middle">{{ Tournament.getStatus(tournament) }}</td>
            <td class="align-middle">
              @if (Tournament.getStatus(tournament) != 'Afgerond') {
                <a mat-button [routerLink]="['/tournaments', tournament.id, 'edit']">
                  <mat-icon>edit</mat-icon>
                  Bewerk
                </a>
              }
              <a mat-button [routerLink]="['/tournaments', tournament.id, 'registrations']">
                <mat-icon>group</mat-icon>
                Inschrijvingen
              </a>
              @if (Tournament.getStatus(tournament) == 'Geloot') {
                <a mat-button (click)="clearDraw(tournament)">
                  <mat-icon>safety_divider</mat-icon>
                  Loting wissen
                </a>
              }
            </td>
          </tr>
        }
      }
      </tbody>
    </table>
    @if (!showInactive) {
      <a mat-button (click)="showInactive = true">
        <mat-icon>expand</mat-icon>
        Toon inactief
      </a>
    }
    <a mat-button routerLink="/tournaments/add">
      <mat-icon>add</mat-icon>
      Nieuw toernooi
    </a>
  </mat-card-content>
</mat-card>

